import React from 'react';
import GridLayout from '../../../../components/GridLayout';
import { LOADER_GRID_DATA } from '../../constants';
import DataLoader from '../../../../components/Common/Loader/DataLoader';

const OverviewLoader = () => {
  function renderLoaderCard({ item }) {
    return <DataLoader isBordered={true} gapBetweenGrids={16} gridData={item?.data} />;
  }

  return <GridLayout gap={20} data={LOADER_GRID_DATA} renderItem={renderLoaderCard} />;
};
export default OverviewLoader;
